/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { skillSummarySchema } from './skillSummarySchema';
import { teamMembershipSummarySchema } from './teamMembershipSummarySchema';

export const teamMemberResponseSchema = z.object({
  capacitySeconds: z.int().nullish(),
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND', 'AI_AGENT']),
  fte: z.number().nullish(),
  inCapacityScope: z.boolean(),
  get memberships() {
    return z.array(teamMembershipSummarySchema);
  },
  resourceId: z.int(),
  resourceName: z.string(),
  resourceSourceId: z.string().nullish(),
  resourceStatus: z.enum(['ACTIVE', 'DEACTIVATED']),
  resourceType: z.enum(['RESOURCE', 'PLACEHOLDER']),
  get skills() {
    return z.array(skillSummarySchema).nullish();
  },
});
